import React from 'react';
import styled from 'styled-components';
import { FlexColumnCenter, Header3, SmallBody } from '@ubeya/shared-web/components';
import { ReactComponent as DefaultEmptyStateIcon } from '@ubeya/shared-web/assets/empty-state-default.svg';
import { media } from '@ubeya/shared-web/style';

const Wrapper = styled(FlexColumnCenter).attrs(() => ({
  className: 'empty-state-wrapper'
}))`
  flex: 1;
  gap: 16px;

  > svg {
    height: 10%;
    width: 10%;
    min-width: 200px;
    min-height: 200px;

    ${media.mobile`
      min-width: 260px;
      min-height: 260px;
  `}
  }
`;
const Text = styled(Header3)`
  font-weight: 500;
`;

const SubText = styled(SmallBody)`
  text-align: center;
`;

export const EmptyState = ({ text, subText, Icon, children, dataTestId }) => {
  return (
    <Wrapper data-testid={dataTestId}>
      {Icon ? <Icon /> : <DefaultEmptyStateIcon />}
      {text && <Text>{text}</Text>}
      {subText && <SubText>{subText}</SubText>}
      {children}
    </Wrapper>
  );
};
